import * as React from "react";
import { tv } from "tailwind-variants";
import { cn } from "@repo/utils/cn";
import { ComponentProps } from "react";
import { SectionHeader, SectionHeaderProps } from "./SectionHeader";
import { sectionWrapper } from "./sectionWrappers";


export interface TextHeaderProps
  extends Omit<ComponentProps<"section">, "content"> {
  content?: SectionHeaderProps | null;
  backgroundColor?: "none" | "light" | "accent" | "accent-light";
  topPadding?: "none" | "default" | "large";
  bottomPadding?: "none" | "default";
}

export const TextHeader: React.FC<TextHeaderProps> = ({
  content,
  backgroundColor = "none",
  topPadding = "none",
  bottomPadding = "none",
  className,
  ...props
}) => {
  if (!content) {
    return null;
  }

  return (
    <section
      className={cn(
        sectionWrapper({ backgroundColor, topPadding, bottomPadding }),
        className
      )}
      {...props}
    >
      <div className="uipm:max-w-[1440px] uipm:mx-auto uipm:px-[var(--container-margin)]">
        <SectionHeader {...content} />
      </div>
    </section>
  );
};
